import styled, { css } from 'styled-components';
// import MuiCardMedia from '@material-ui/core/CardMedia';
import { CardContent as MuiCardContent, Card as MuiCard, CardHeader as MuiCardHeader } from '@mui/material';
import { makeStyles } from '@mui/styles';
import MuiAvatar from '@atoms/Avatar';
import Typography from '@atoms/Typography';
import Link from '@atoms/Link';
import { deviceSizes } from '@app/config/devices';
// export const CardMedia = styled(MuiCardMedia)`
//   height: 15.625rem;
//   && {
//     border-bottom: 4px solid red;
//   }
// `;

export var CardContent = styled(MuiCardContent).withConfig({
  displayName: "style__CardContent",
  componentId: "sc-kka0fh-0"
})(["display:flex;position:relative;border-top:4px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.primary.main;
});
export var StyledLink = styled(Link).withConfig({
  displayName: "style__StyledLink",
  componentId: "sc-kka0fh-1"
})(["&&{color:white;text-decoration:none;& :hover{text-decoration:underline;}}"]);
export var ContentContainer = styled.div.withConfig({
  displayName: "style__ContentContainer",
  componentId: "sc-kka0fh-2"
})(["display:flex;flex-direction:column;width:100%;"]);
export var Card = styled(MuiCard).withConfig({
  displayName: "style__Card",
  componentId: "sc-kka0fh-3"
})(["&&{position:relative;border-radius:10px;transition:all 600ms cubic-bezier(0.4,0,0.2,1) 0ms;height:100%;& :hover{.additionalInfo{top:0px;}}@media (max-width:", "){margin-right:16px;}}"], deviceSizes.sm);
export var CardHeader = styled(MuiCardHeader).withConfig({
  displayName: "style__CardHeader",
  componentId: "sc-kka0fh-4"
})(["&&{padding:0;.MuiCardHeader-action{align-self:flex-end;}}"]);
export var CardLabel = styled(Typography).withConfig({
  displayName: "style__CardLabel",
  componentId: "sc-kka0fh-5"
})(["display:flex;&&{color:", ";}&:hover{cursor:pointer;}overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-moz-box-orient:vertical;-webkit-box-orient:vertical;-webkit-line-clamp:2;height:60px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme && theme.secondaryColor[800];
});
export var CardSublabel = styled(Typography).withConfig({
  displayName: "style__CardSublabel",
  componentId: "sc-kka0fh-6"
})(["text-overflow:ellipsis;display:-webkit-box;-moz-box-orient:vertical;-webkit-box-orient:vertical;-webkit-line-clamp:1;height:14px;"]);
export var MetaItem = styled.div.withConfig({
  displayName: "style__MetaItem",
  componentId: "sc-kka0fh-7"
})(["display:flex;margin-bottom:0.5rem;align-items:center;svg{margin-right:1rem;}"]);
export var OrganisationAvatar = styled(MuiAvatar).withConfig({
  displayName: "style__OrganisationAvatar",
  componentId: "sc-kka0fh-8"
})(["&&{position:absolute;right:18px;top:-32px;border:3px solid ", ";box-shadow:0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.primary.main;
});
export var OpportunityDescription = styled(Typography).withConfig({
  displayName: "style__OpportunityDescription",
  componentId: "sc-kka0fh-9"
})(["overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-moz-box-orient:vertical;-webkit-box-orient:vertical;-webkit-line-clamp:4;"]);
export var useClasses = makeStyles(function () {
  return {
    image: {
      width: '100%',
      height: '200px'
      // '& > div': {
      // borderBottom: `4px solid ${theme.palette.primary.main}`,
      // },
    },
    mediaContainer: {
      position: 'relative',
      overflow: 'hidden'
      // '&:hover': {
      //   '& .additionalInfo': {
      //     top: '0px',
      //   },
      // },
    },
    additionalInfo: {
      position: 'absolute',
      top: '200px',
      height: '100%',
      background: 'rgba(0,0,0,0.65)',
      width: '100%',
      color: 'white',
      padding: '20px',
      transition: 'all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      display: 'flex',
      flexDirection: 'row'
    },
    details: {
      display: 'flex',
      flexBasis: '80%',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    stats: {
      display: 'flex',
      flexBasis: '20%',
      flexDirection: 'column',
      justifyContent: 'start',
      alignItems: 'flex-end'
    }
  };
});